import { render } from "./PeopleView.vue?vue&type=template&id=366c57a9&scoped=true"
import script from "./PeopleView.vue?vue&type=script&lang=js"
export * from "./PeopleView.vue?vue&type=script&lang=js"

import "./PeopleView.vue?vue&type=style&index=0&id=366c57a9&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366c57a9"]])

export default __exports__